import { Avatar, Modal, Stack, Typography } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { AppColors } from '../../Utils/helper/AppColors';
import UserDetails from './UserDetails';
import { getInitials } from '../../Utils/helper/commonUtils';
import toast from 'react-hot-toast';
import NewUserDetails from './NewUserDetails';
import CustomInfoTooltip from '../CustomInfoTooltip';

// userId -> to open model
//user -> to show user details

export default function UserThumbnail({ user, hideName, thumbnail, size, vertical, userId, type, noPagination, TextColor, textFontSize }) {
    const [showDetails, setShowDetails] = useState(false);
    const [isOverflow, setIsOverflow] = useState(false);
    const nameRef = useRef(null);

    useEffect(() => {
        if (nameRef.current) {
            setIsOverflow(nameRef.current.scrollWidth > nameRef.current.clientWidth);
        }
    }, [user?.firstName, user?.lastName, textFontSize]);

    const displayName = user?.anonymous || !user ? 'Anonymous' : `${user?.firstName || ''} ${user?.lastName || ''}`;

    const getUsername = function () {
        let username = user?.anonymous ? '****' : (user?.firstName || user?.name)?.split(' ')?.[0]?.toLowerCase();
        return `@${username || 'na'}`;
    };

    const handleUser = () => {
        if (userId) {
            setShowDetails(true);
        }
    };

   
   return (
      
        <>
            <Stack
                onClick={handleUser}
                sx={{ cursor: 'pointer' }}
                direction={vertical ? 'column' : 'row'}
                alignItems="center"
                gap={1.4}
            >
                {user?.image ? (
                    <Avatar
                        sx={{ height: size || 34, width: size || 34 }}
                        src="https://img.freepik.com/free-photo/portrait-young-woman-with-natural-make-up_23-2149084942.jpg"
                    />
                ) : (
                    thumbnail && (
                        <Stack
                            flexShrink={0}
                            height={size || 34}
                            width={size || 34}
                            borderRadius={50}
                            border="1px solid"
                            alignItems="center"
                            justifyContent="center"
                            sx={theme => ({ cursor: 'pointer', transition: 'all .2s', borderColor: theme.palette.primary.light_shade , backgroundColor: theme.palette.primary.lightest_shade  ,':hover': { bgcolor: '#e4e6eb' } })}
                        >
                            <Typography variant="subtitle2">{getInitials({ user })}</Typography>
                        </Stack>
                    )
                )}
                {!hideName && (
                    <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={1}>
                        <Typography
                            ref={nameRef}
                            fontWeight={600}
                            fontSize={textFontSize || 14}
                            fontFamily="Poppins"
                            sx={theme => ({
                                color : TextColor || theme.palette.primary.darker_primary,
                                minWidth: '80px',
                                maxWidth: '200px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textTransform: 'capitalize',
                            })}
                        >
                            {displayName}
                        </Typography>
                        {isOverflow && (
                            <CustomInfoTooltip title={displayName} iconSize={18} placement="right" />
							
                        )}
                    </Stack>
                )}
            </Stack>
            <Modal open={showDetails} onClose={() => setShowDetails(false)}>
                <NewUserDetails onClose={() => setShowDetails(false)} userId={userId} type={type} noPagination={noPagination} />
            </Modal>
        </>
    );
}
